import React from "react";
/**
 * @param {{errors: {key: string, message: string}[], onClose: () => void}} args
 * @returns
 */

export function ErrorDialog({ errors, onClose }) {
  if (!errors.length) return null;

  return (
    <div className="error-dialog-backdrop" onClick={onClose}>
      <div
        className="error-dialog"
        onClick={(e) => e.stopPropagation()} // prevent backdrop click from bubbling
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="error-dialog-title"
      >
        <div className="error-dialog__header" id="error-dialog-title">
          Error loading sales
        </div>

        <ul className="error-dialog__list">
          {errors.map((e) => (
            <li key={e.key}>{e.message}</li>
          ))}
        </ul>

        <div className="error-dialog__actions">
          <button className="error-dialog__ok-btn" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
